'use client';

import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

const loginSchema = z.object({
  email: z.string().email('Email invalide'),
  password: z.string().min(6, 'Mot de passe trop court'),
});

type LoginForm = z.infer<typeof loginSchema>;

export default function LoginPage() {
  const router = useRouter();
  const { register, handleSubmit, formState: { errors } } = useForm<LoginForm>({
    resolver: zodResolver(loginSchema)
  });

  const onSubmit = (data: LoginForm) => {
    console.log('Login attempt:', data);
    // Mock login
    router.push('/dashboard');
  };

  return (
    <div className="glass-card p-8">
      <h1 className="text-2xl font-display font-bold mb-6 text-center">Bon retour !</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-surface-300 mb-1">Email</label>
          <input 
            type="email" 
            {...register('email')}
            className="w-full bg-surface-900 border border-glass-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500 transition-colors"
            placeholder="jean@dupont.fr"
          />
          {errors.email && <p className="text-danger text-sm mt-1">{errors.email.message}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-surface-300 mb-1">Mot de passe</label>
          <input 
            type="password" 
            {...register('password')}
            className="w-full bg-surface-900 border border-glass-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500 transition-colors"
            placeholder="••••••••"
          />
          {errors.password && <p className="text-danger text-sm mt-1">{errors.password.message}</p>}
        </div>
        
        <button type="submit" className="w-full bg-amber-500 hover:bg-amber-400 text-surface-950 font-bold py-3 rounded-xl transition-all shadow-[0_0_15px_rgba(245,158,11,0.2)] mt-2">
          Se connecter
        </button>
      </form>
      
      <p className="mt-6 text-center text-surface-400 text-sm">
        Pas encore de compte ?{' '}
        <Link href="/register" className="text-amber-500 hover:underline font-medium">
          S'inscrire
        </Link>
      </p>
    </div>
  );
}
